import React from 'react';
import CostAdjustmentApi from "../../api/costAdjustmentapi";
import { Form, Input, Label, Button, Row, Col } from 'reactstrap';
class costAdjustmentCreate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            costAdjustment: {
                name: '',
                adjustmentType: '',
                adjustment: '',
                updatedBy: '', 
                startDate: '',
                endDate: '',
                productId: this.props.match.params.productId
            }

        }

        this.costAdjustmentApi = new CostAdjustmentApi();
    }

    handleFormSubmit(event) {
        event.preventDefault();
        console.log(this.state.costAdjustment)
        this.costAdjustmentApi.createCostAdjustmentByProductId(this.state.costAdjustment).then(response => {
            console.log(response);
        });
    }

    render() {
        return (

            <div className="col-md-10 mt-5">
                <h1>New Cost Adjustment</h1>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col>
                            <Label>CostAdjustment Type</Label>
                            <Input name="name" value={this.state.costAdjustment.adjustmentType}
                                onChange={(e) => { var x = this.state.costAdjustment; x.adjustmentType = e.target.value; this.setState({ costAdjustment: x }) }} />
                        </Col>
                        <Col>
                            <Label>Adjustment</Label>
                            <Input name="costAdjustmentCode" value={this.state.costAdjustment.adjustment}
                                onChange={(e) => { var x = this.state.costAdjustment; x.adjustment = e.target.value; this.setState({ costAdjustment: x }) }} />
                        </Col>
                    </Row>
                    <div className="mt-5">
                        <Row>
                            <Col>

                                <Label>StartDate</Label>
                                <Input type="date" name="startDate" value={this.state.costAdjustment.startDate}
                             onChange = {(e) => {var x = this.state.costAdjustment; x.startDate = e.target.value; this.setState({costAdjustment:x})}}/>
                            </Col>
                            <Col>

                                <Label>EndDate</Label>
                                <Input type="date" name="endDate" value={this.state.costAdjustment.endDate}
                             onChange = {(e) => {var x = this.state.costAdjustment; x.endDate = e.target.value; this.setState({costAdjustment:x})}}/>
                            </Col>
                        </Row>
                    </div>
                    <div className="text-right">
                        <Button type="submit" onClick={e => this.handleFormSubmit(e)} color="primary">
                            Create
                    </Button>
                    </div>
                </Form>
            </div>
        );
    }
}
export default costAdjustmentCreate;